export function calculateImagePaddings(region, imageWidth, maxWidth) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let outlookImagePaddingLeft;
    let outlookImagePaddingRight;
    let imagePaddingLeft;
    let imagePaddingRight;
    let adjustedimageWidth = imageWidth;
    if (((_c = (_b = (_a = region.data) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.region) === null || _c === void 0 ? void 0 : _c.paddingRight) ||
        ((_f = (_e = (_d = region.data) === null || _d === void 0 ? void 0 : _d.styles) === null || _e === void 0 ? void 0 : _e.region) === null || _f === void 0 ? void 0 : _f.paddingLeft)) {
        // NOTE: Code below is written with assumption that paddingLeft and
        // paddingRight are equal or one of them is zero.
        const paddingRight = ((_g = region.data.styles.region.paddingRight) === null || _g === void 0 ? void 0 : _g.endsWith('%'))
            ? parseInt(region.data.styles.region.paddingRight, 10)
            : undefined;
        const paddingLeft = ((_h = region.data.styles.region.paddingLeft) === null || _h === void 0 ? void 0 : _h.endsWith('%'))
            ? parseInt(region.data.styles.region.paddingLeft, 10)
            : undefined;
        const imageScale = 100 - ((paddingLeft || 0) + (paddingRight || 0));
        adjustedimageWidth = Math.floor((imageWidth * imageScale) / 100);
        const totalPadding = ((maxWidth - adjustedimageWidth) * 100) / maxWidth;
        imagePaddingLeft =
            paddingRight === undefined
                ? totalPadding
                : paddingLeft !== undefined
                    ? totalPadding / 2
                    : 0;
        imagePaddingRight =
            paddingLeft === undefined
                ? totalPadding
                : paddingRight !== undefined
                    ? totalPadding / 2
                    : 0;
        outlookImagePaddingLeft = (imagePaddingLeft * maxWidth) / 100;
        outlookImagePaddingRight = (imagePaddingRight * maxWidth) / 100;
    }
    return {
        imagePaddingLeft,
        imagePaddingRight,
        outlookImagePaddingLeft,
        outlookImagePaddingRight,
        adjustedimageWidth,
    };
}
//# sourceMappingURL=calculate-image-paddings.js.map